export const getStatusBannerErrorMessage = (
  error: unknown,
  t: (key: string) => string,
): string => {
  const status =
    typeof error === "object" && error !== null && "status" in error
      ? (error as { status?: unknown }).status
      : undefined;

  if (status === 403) {
    return t("common.statusBanner.error.forbidden");
  }
  return t("common.statusBanner.error.generic");
};
